// extracted by mini-css-extract-plugin
export var discountCodeBubbleContainer = "_n5-0";
export var discountCodeInput = "_n5-1";